<template>
  <v-container fluid>
    <v-row>
      <v-card tile class="mt-5 mb-5 pb-5">
        <v-card-title class="font-weight-bold text-justify black--text">{{labTitle}}</v-card-title>
        <v-card-text class="text-subtitle-1 black--text text-justify pb-0" v-for="(item, index) in labBlob" :key="index">{{item}}</v-card-text>
      </v-card>

      <v-btn
          v-scroll="onScroll"
          v-show="fab"
          fab
          dark
          fixed
          bottom
          left
          color="primary"
          @click="toTop"
      >
        <v-icon x-large>mdi-arrow-up</v-icon>
      </v-btn>

      <v-btn
          v-show="true"
          dark
          tile
          color="primary"
          class="mb-3"
          @click="() => {
            this.$router.push('/lab')
          }"
      >
        Назад
      </v-btn>

    </v-row>
  </v-container>
</template>

<script>
import {getLabParagraphs} from "@/helpers/labText";

export default {
  name: "LabAboutPage",
  data () {
    return {
      labBlob: [],
      labTitle: '',
      fab: 0
    }
  },

  methods: {
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    }
  },

  created() {
    const paragraphs = getLabParagraphs()
    this.labBlob = paragraphs.paragraphs
    this.labTitle = paragraphs.labTitle
  }
}
</script>

<style scoped>

</style>